import React from 'react';

function VerifiedUserIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49167 3.64688L9.325 1.05522C9.75 0.863552 10.25 0.863552 10.675 1.05522L16.5083 3.64688C17.1083 3.91355 17.5 4.51355 17.5 5.17189V9.08855C17.5 13.7136 14.3 18.0385 10 19.0886C5.7 18.0385 2.5 13.7136 2.5 9.08855V5.17189C2.5 4.51355 2.89167 3.91355 3.49167 3.64688ZM5.58333 11.3386L7.74167 13.4969C8.06667 13.8219 8.6 13.8219 8.91667 13.4969L14.4083 8.00522C14.7333 7.68022 14.7333 7.15522 14.4083 6.83022C14.0833 6.50522 13.5583 6.50522 13.2333 6.83022L8.33333 11.7302L6.75833 10.1636C6.43333 9.83855 5.90833 9.83855 5.58333 10.1636C5.42729 10.3192 5.3396 10.5306 5.3396 10.7511C5.3396 10.9715 5.42729 11.1829 5.58333 11.3386Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default VerifiedUserIcon;
